import { _ } from "i18n";

interface DiscoverGamesProgramGameButtonProps {
	canProgramGame: boolean;
	onClick: () => void;
}

export function DiscoverGamesProgramGameButton({
	canProgramGame,
	onClick,
}: DiscoverGamesProgramGameButtonProps) {
	return (
		<button
			type="button"
			className="discoverGamesTableV3-columnBtn"
			onClick={onClick}
			title={
				canProgramGame
					? _("discover.gamesTable.programGame.button")
					: _("discover.gamesTable.programGame.noPermissionHint")
			}
			disabled={!canProgramGame}
		>
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
				<path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			</svg>
			{_("discover.gamesTable.programGame.button")}
		</button>
	);
}
